import { render, staticRenderFns } from "./breed-form-select.vue?vue&type=template&id=22482c34&"
import script from "./breed-form-select.vue?vue&type=script&lang=js&"
export * from "./breed-form-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports